export function adjustColumnWidth(table: any) {
  const colgroup = table.querySelector("colgroup")
  const colDefs = [...colgroup.querySelectorAll("col")]
  colDefs.forEach((col) => {
    const clsName = col.getAttribute("name")
    const cells = [...table.querySelectorAll(`td.${clsName}`), ...table.querySelectorAll(`th.${clsName}`)]
    // 忽略加了"leave-alone"类的列
    if (cells[0]?.classList?.contains?.("leave-alone")) {
      return
    }
    const widthList = cells.map((el) => {
      return el.querySelector(".cell")?.scrollWidth || 0
    })
    const max = Math.max(...widthList)
    const padding = 20
    table.querySelectorAll(`col[name=${clsName}]`).forEach((el: any) => {
      el.setAttribute("width", max + padding)
    })
  })

  // 此段代码放入 adjustColumnWidth 内部最后面即可。
  const scrollingBody = table
  if (scrollingBody.classList?.contains?.("is-scrolling-none")) {
    scrollingBody.classList.remove("is-scrolling-none")
    scrollingBody.classList.add("is-scrolling-left")
    scrollingBody.style.overflowX = "auto"
  }
}
